import { axiosClient } from "../axios";

const baseUrl = "/api/esg/dsr/@dsrId@/documents";

// La sostituzione testuale nuda accetterebbe 0/undefined/null componendo una URL valida che il
// server rifiuta con 404 o 401, indistinguibile lato utente da un guasto. Si fallisce prima della
// request, nominando il chiamante.
function replaceDsrId(dsrId, caller) {
  const id = Number(dsrId);
  if (!Number.isInteger(id) || id <= 0) {
    throw new Error(
      `DsrUploadedDocumentApi.${caller}: identificativo DSR mancante o non valido (${dsrId})`
    );
  }
  return baseUrl.replace("@dsrId@", id);
}

export function get(dsrId) {
  const route = replaceDsrId(dsrId, "get");
  return axiosClient.get(`${route}`);
}

// VSME bulk upload: files + types, no facility. The AI assigns the facility afterwards.
export function saveBulk(dsrId, formData) {
  const route = replaceDsrId(dsrId, "saveBulk");
  return axiosClient.post(`${route}/bulk`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

// Confirm document -> facility assignments and start the extraction + parse pipeline.
export function confirmFacilityMatches(dsrId, matches) {
  const route = replaceDsrId(dsrId, "confirmFacilityMatches");
  return axiosClient.post(`${route}/confirm-facility-matches`, { matches });
}

export function remove(dsrId, documentIds) {
  const route = replaceDsrId(dsrId, "remove");
  return axiosClient.post(`${route}/delete`, documentIds);
}

export function download(dsrId, id) {
  const route = replaceDsrId(dsrId, "download");
  const config = {
    responseType: "blob",
  };
  return axiosClient.get(`${route}/${id}/download`, config);
}

export function getAllDsrOutputData(dsrId) {
  const route = replaceDsrId(dsrId, "getAllDsrOutputData");
  return axiosClient.get(`${route}/output-data`);
}

// Scarica il template DSR di esempio
export function downloadFleetSampleTemplate(dsrId) {
  const route = replaceDsrId(dsrId, "downloadFleetSampleTemplate");
  return axiosClient.get(`${route}/excel/fleet/template`, {
    responseType: "blob",
  });
}

export function getDocumentsStatus(dsrId) {
  const route = replaceDsrId(dsrId, "getDocumentsStatus");
  return axiosClient.get(`${route}/status`);
}

export function getPresignedUrl(dsrId, documentId) {
  const route = replaceDsrId(dsrId, "getPresignedUrl");
  return axiosClient.get(`${route}/${documentId}/presigned-url`);
}
